const __WEBPACK_NAMESPACE_OBJECT__ = require("@chaitanyapotti/register-service-worker");